// Configuration de l'URL de base de l'API backend
const rawBase = process.env.REACT_APP_API_URL || 'http://localhost:8080';
export const BACKEND_BASE_URL = rawBase.replace(/\/$/, '');
export const API_BASE_URL = `${BACKEND_BASE_URL}/api`;

/**
 * Converts a backend-relative file path (e.g. "/uploads/foo.pdf")
 * into a fully-qualified URL pointing at the Spring backend.
 *
 * Without this, a bare <a href="/uploads/foo.pdf"> would navigate
 * to the React dev-server (port 3000) instead of the backend (port 8080)
 * and trigger a NoResourceFoundException.
 */
export const getFileUrl = (fileUrl) => {
  if (!fileUrl) return '#';
  // Already absolute (http:// or https://) – return as-is
  if (fileUrl.startsWith('http://') || fileUrl.startsWith('https://')) return fileUrl;
  // Relative backend path – prepend the backend base URL
  return `${BACKEND_BASE_URL}${fileUrl.startsWith('/') ? '' : '/'}${fileUrl}`;
};